// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"fa710bf7","393":"052e54c8","441":"a821ab64","453":"4f06d180","716":"84bcd96f","870":"e5c5be4d","965":"eaf542aa"}[chunkId] + ".css";
};